import React from 'react';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { useSelector } from 'react-redux';
import { SummaryLabelledInfo } from '../labelled-info';
import { SummaryTable } from '../table';
import { useSelectConfiguration } from '../../../../../app/use-app';
import { RootState } from '../../../../../../global';
import { useLegalShareholders } from '../../../../../admin/buy-process/organizations/use-organizations';
import { selectBuyPhysicalPeopleFactory } from '../../../../../../services/buy-process/selectors';

interface SummaryOwnerSharesProps {
  orderId: string;
}

export const SummaryOwnerShares = ({ orderId }: SummaryOwnerSharesProps) => {
  const { beneficialOwnerHelp, numberShares, shareCapital } = useSelector(
    (state: RootState) => state.buyOrderEdit[orderId].ownerShares,
  );
  const { fees } = useSelectConfiguration();

  const physicalPeopleColumns = [
    'Samtliga förnamn',
    'Efternamn',
    'Personnummer',
    'Utdelningsadress',
    'Postnummer',
    'Ort',
    'Antal aktier',
  ];

  const legalEntitiesColumns = [
    'Organisationens namn',
    'Org. nummer',
    'Utdelningsadress',
    'Postnummer',
    'Ort',
    'Antal aktier',
    'Företrädarens förnamn',
    'Företrädarens efternamn',
    'Företrädarens personnummer',
  ];

  const physicalPeople = useSelector(selectBuyPhysicalPeopleFactory(orderId));
  const legalShareholders = useLegalShareholders(orderId);

  // TODO: Remove any from legal shareholders
  return (
    <React.Fragment>
      <SummaryLabelledInfo label="Aktiekapital">
        {shareCapital === 25000 ? '25,000' : '50,000'} SEK / {numberShares}{' '}
        aktier
      </SummaryLabelledInfo>

      {physicalPeople.length > 0 && (
        <SummaryLabelledInfo isTable label="Fysiska personer">
          <SummaryTable columns={physicalPeopleColumns}>
            {physicalPeople.map((x, index) => (
              <TableRow key={index}>
                <TableCell>{x.firstName}</TableCell>
                <TableCell>{x.lastName}</TableCell>
                <TableCell>{x.socialSecurityNumber}</TableCell>
                <TableCell>{x.address}</TableCell>
                <TableCell>{x.postalCode}</TableCell>
                <TableCell>{x.city}</TableCell>
                <TableCell>{x.numberShares}</TableCell>
              </TableRow>
            ))}
          </SummaryTable>
        </SummaryLabelledInfo>
      )}

      {legalShareholders.length > 0 && (
        <SummaryLabelledInfo isTable label="Juridiska personer">
          <SummaryTable columns={legalEntitiesColumns}>
            {legalShareholders.map((x: any, index) => (
              <TableRow key={index}>
                <TableCell>{x.organizationName}</TableCell>
                <TableCell>{x.organizationNumber}</TableCell>
                <TableCell>{x.organizationAddress}</TableCell>
                <TableCell>{x.organizationPostalCode}</TableCell>
                <TableCell>{x.organizationCity}</TableCell>
                <TableCell>{x.numberShares}</TableCell>
                <TableCell>{x.firstName}</TableCell>
                <TableCell>{x.lastName}</TableCell>
                <TableCell>{x.socialSecurityNumber}</TableCell>
              </TableRow>
            ))}
          </SummaryTable>
        </SummaryLabelledInfo>
      )}

      {beneficialOwnerHelp && (
        <SummaryLabelledInfo label="Registrera huvudman">
          Ja, tack! +{fees.beneficalFee} kr (inkluderar Bolagsverkets avgift om
          250 kr).
        </SummaryLabelledInfo>
      )}
    </React.Fragment>
  );
};
